import {
  updateResourceState,
  createResourceReducer,
  RESOURCE
} from '@unicus/react-ui-kit';
import { PAYMENT, RECEIPT } from 'constants/types';
import moment from 'moment';
import {
  FINANCIALSTATISTIC,
  FINANCIALSTATISTIC_GET_CASHFLOW,
  FINANCIALSTATISTIC_GET_CASHFLOW_FINISHED,
  FINANCIALSTATISTIC_GET_SUMMARY,
  FINANCIALSTATISTIC_GET_SUMMARY_FINISHED,
  FINANCIALSTATISTIC_GET_TOP_PAYMENT_CATEGORIES,
  FINANCIALSTATISTIC_GET_TOP_PAYMENT_CATEGORIES_FINISHED,
  FINANCIALSTATISTIC_GET_TOP_RECEIPT_CATEGORIES,
  FINANCIALSTATISTIC_GET_TOP_RECEIPT_CATEGORIES_FINISHED,
  FINANCIALSTATISTIC_GET_TOTAL_LAST_MONTH,
  FINANCIALSTATISTIC_GET_TOTAL_LAST_MONTH_FINISHED
} from './financialStatisticActions';

const handleError = (state, action) => {
  return updateResourceState(state, action, RESOURCE, () => ({
    saving: false,
    loading: false,
    [`${RECEIPT}LoadingTopCategories`]: false,
    [`${PAYMENT}LoadingTopCategories`]: false,
    loadingSummary: false,
    loadingCashFlow: false
  }));
};

const financialStatisticReducer = createResourceReducer(
  FINANCIALSTATISTIC,
  [],
  {
    [FINANCIALSTATISTIC_GET_TOP_RECEIPT_CATEGORIES](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        [`${RECEIPT}LoadingTopCategories`]: true
      }));
    },

    [FINANCIALSTATISTIC_GET_TOP_RECEIPT_CATEGORIES_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        [`${RECEIPT}LoadingTopCategories`]: false,
        [`${RECEIPT}TopCategories`]: action.payload?.data
      }));
    },

    [FINANCIALSTATISTIC_GET_TOP_PAYMENT_CATEGORIES](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        [`${PAYMENT}LoadingTopCategories`]: true
      }));
    },

    [FINANCIALSTATISTIC_GET_TOP_PAYMENT_CATEGORIES_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        [`${PAYMENT}LoadingTopCategories`]: false,
        [`${PAYMENT}TopCategories`]: action.payload?.data
      }));
    },

    [FINANCIALSTATISTIC_GET_TOTAL_LAST_MONTH](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({}));
    },

    [FINANCIALSTATISTIC_GET_TOTAL_LAST_MONTH_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        totalLastMonths: action.payload?.data
      }));
    },

    [FINANCIALSTATISTIC_GET_SUMMARY](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loadingSummary: true
      }));
    },

    [FINANCIALSTATISTIC_GET_SUMMARY_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loadingSummary: false,
        summary: action.payload.data
      }));
    },

    [FINANCIALSTATISTIC_GET_CASHFLOW](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loadingCashFlow: true
      }));
    },

    [FINANCIALSTATISTIC_GET_CASHFLOW_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loadingCashFlow: false,
        cashFlow: action.payload.data
      }));
    }
  },
  handleError
);

export default financialStatisticReducer;
